export default {
  addRole: 'Add Role',
  id: 'ID',
  role: 'Role',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  addRoleTitle: 'Add Role',
  editRoleTitle: 'Edit Role',
  roleName: 'Role Name',
  roleNamePlaceholder: 'Please enter role name',
  rolePermissions: 'Role Permissions',
  cancel: 'Cancel',
  confirm: 'Confirm',
  level1Menu: 'Level 1 Menu',
  level2Menu: 'Level 2 Menu',
  confirmDelete: 'Are you sure you want to delete this role?',
};
